import { useMutation } from '@tanstack/react-query';
import toastMsg from '../../lib/toastMsg';
import BrandApiV2 from '../../lib/api/brand/BrandApiV2';
import { BrandsExcelUploadResponseDto } from '../../types/api/brands';
import { ResponseError } from '../../types/common/api';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

interface ProductListExcelProps {
  onUploadSuccess: (res: BrandsExcelUploadResponseDto) => void;
}
export const useBrandListExcel = (props: ProductListExcelProps) => {
  const { onUploadSuccess } = props;
  const { mutate: uploadBrandListExcel } = useMutation(BrandApiV2.uploadExcel, {
    onSuccess: onUploadSuccess,
    onError: (error: ResponseError) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });
  const { mutate: downloadBrandListExcel } = useMutation(BrandApiV2.downloadExcel, {
    onSuccess: ({ adminEmail }) => {
      toastMsg.success(`${adminEmail}로 엑셀이 발송되었습니다`);
    },
  });

  return { uploadBrandListExcel, downloadBrandListExcel };
};
